import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DialogSharedComponent} from '../../dialog-shared/dialog-shared.component';
import {ShipmentDialogComponent} from '../shipment-dialog/shipment-dialog.component';
import {MatDialog} from '@angular/material';
import {MatSnackBar} from '@angular/material';
import {OrdersService} from '@services/orders.service';
import {ExtraFeesDialogComponent} from '../extra-fees/extra-fees.component';
import {SnackBarComponent} from '@components/snackbar/snackbar.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'order-table',
  templateUrl: './order-table.component.html'
})

export class OrderTableComponent {
  shipment_ref: string;
  @Input() orders: any;
  @Input() shipments: any;
  @Input() dataAll: any;
  @Input() shipmentsEnable: any;
  @Input() progress: any;

  @Output() getOrd: EventEmitter<any> = new EventEmitter();
  prevshipmentsEnable = 0;

  constructor(
    public dialog: MatDialog,
    private orderService: OrdersService,
    private matSnackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  shipmentsOpen(num) {
    this.shipments = this.dataAll.data[num].shipments;
    for (const ship in this.shipments) {
      if (this.orders[num].canceled_at === true || this.shipments[ship].canceled_at != null) {
        this.shipments[ship].canceled_at = true;
      }
    }
    if (this.shipmentsEnable[num]) {
      this.shipmentsEnable[num] = false;
    } else {
      /*
      if (this.prevshipmentsEnable != 0) {
          this.shipmentsEnable[this.prevshipmentsEnable] = false;
      }*/
      for (const i in this.shipmentsEnable) {
        this.shipmentsEnable[i] = false;
      }
      this.shipmentsEnable[num] = true;
    }
    this.prevshipmentsEnable = num;
    return false;
  }
  setTime(time) {
    const arrDateTime = time.split(' ');
    const arrTime = arrDateTime[1].split(':');
    const user_date = new Date();
    const user_time = user_date.getTimezoneOffset();
    const localTime = arrTime[0] - (user_time / 60) + ':' + arrTime[1] + ':' + arrTime[2];
    const result = arrDateTime[0] + ' ' + localTime;

    return result;
  }
  setApprove(e, order_num, id, order_number, order) {
    e.stopPropagation();
    let shipments = 0;
    let created = 0;
    for (let i = 0; i < order.shipments.length; i++) {
      if (order.shipments[i].status === 'Stored') {shipments++; }
      if (order.shipments[i].status === 'Created') {created++; }
    }
    const paramText = {shipments: shipments, created: created};

    const dialogRef = this.dialog.open(DialogSharedComponent,
      {width: '350px', data: { id: order_num, bodyText: { text: 'order.approveManually', param: paramText} }});
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.progress = true;
        this.orderService.setApprove(id).subscribe((resp) => {
          this.getOrd.emit();
          this.progress = false;
        }, error => {
          this.progress = false;
        });

      }
    });

  }

  cancel(e, order_num, id, order_number) {
    console.log('cancel order');
    e.stopPropagation();
    if (this.orders[order_num].canceled_at === false) {
      if (confirm(this.translate.instant('common.messages.order.cancelConfirm', {order: order_number}))) {
        this.orderService.cancelOrder(id).subscribe((resp) => {
          this.getOrd.emit();
          this.orders[order_num].canceled_at = true;
          this.matSnackBar.openFromComponent(SnackBarComponent, {
            data: {
              error: false,
              message: this.translate.instant('common.messages.order.canceled')
            },
            panelClass: 'snackbar-container',
            duration: 3000
          });
        });
      }
    }
    return false;
  }

  markShipment(event, shipmentId) {
    const paramText = {shipments: event, created: ''};
    const shipment_ref = {'shipment_ref': event};
    const dialogRef = this.dialog.open(DialogSharedComponent,
      {
        width: '350px',
        data: {
          id: shipmentId,
          bodyText: {
            text: 'admin.navigation.sidenav.orders.markShipment',
            param: paramText
          }
        }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.progress = true;
        this.orderService.markAsCreated(shipmentId, shipment_ref).subscribe((resp) => {
          this.getOrd.emit();
          this.progress = false;
        }, error => {
          this.progress = false;
        });

      }
    });
  }
  openWindow(href) {
    window.open(href, '');
    return false;
  }

  openInfoDialog(details_num) {
    const dialogRef = this.dialog.open(ShipmentDialogComponent, {width: '680px'});
    dialogRef.componentInstance.details = this.shipments[details_num];
  }
  cancelShip(e, order_num, shipment_num, order_id, shipment_id, shipment_ref) {
    e.stopPropagation();
    if (this.shipments[shipment_num].canceled_at == null) {
      if (confirm(this.translate.instant('common.messages.shipment.cancelConfirm', {consignment: shipment_ref}))) {
        this.orderService.cancelShipment(order_id, shipment_id).subscribe((resp) => {
          this.shipments[shipment_num].canceled_at = true;
          this.matSnackBar.openFromComponent(SnackBarComponent, {
            data: {
              error: false,
              message: this.translate.instant('common.messages.shipment.canceled')
            },
            panelClass: 'snackbar-container',
            duration: 3000
          });
        });
      }
    }
    return false;
  }
  openFeesDialog(details_num) {
    const dialogRef = this.dialog.open(ExtraFeesDialogComponent, {width: '680px'});
    const shipment = this.shipments[details_num];
    dialogRef.componentInstance.orderId = shipment.order_id;
    // dialogRef.componentInstance.shipmentId = shipment.openFeesDialogid;
    dialogRef.componentInstance.shipmentId = shipment.id;
    dialogRef.componentInstance.oldEtraCharges = shipment.extra_charge_payments;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'update') {
        this.getOrd.emit();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/order-table/order-table.component.ts